<template>
  <MainMenuDesktop
    v-if="windowWidth >= 1320"
    :animation-enabled="animationEnabled"
    :routes="routes"
  />
  <MainMenuMobile
    v-else
    :animation-enabled="animationEnabled"
    :routes="routes"
    :lock-scroll="true"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import MainMenuDesktop from './main-menu-desktop';
import MainMenuMobile from './main-menu-mobile';

export default {
  props: {
    animationEnabled: {
      type: Boolean,
      default: true,
    },
    routes: {
      type: Array,
      default: () => [],
    },
  },
  components: { MainMenuDesktop, MainMenuMobile },
  computed: {
    ...mapGetters('layoutModule', ['windowWidth']),
  },
};
</script>
